import {
  MenuItemsType,
  DropdownMenuItemType,
  SwapIcon,
  SwapFillIcon,
  EarnFillIcon,
  PancakeProtectorIcon,
  EarnIcon,
  TrophyIcon,
  TrophyFillIcon,
  NftIcon,
  NftFillIcon,
  MoreIcon,
  DropdownMenuItems,
  IfoIcon,
  BscScanIcon, BridgeIcon,
} from '@pancakeswap/uikit'
import { ContextApi } from '@pancakeswap/localization'
import {
  DACKIE_PAD_SUPPORTED_CHAIN_IDS, INFO_SUPPORTED_CHAIN_IDS,
  NFT_POOL_SUPPORTED_CHAIN_IDS,
  SUPPORTED_CHAIN_IDS,
  SUPPORTED_CHAIN_IDS as POOL_SUPPORTED_CHAINS
} from "@pancakeswap/pools";
import { nftsBaseUrl } from 'views/Nft/market/constants'
import { getPerpetualUrl } from 'utils/getPerpetualUrl'
import { SUPPORT_FARMS, SUPPORT_ONLY_BSC } from 'config/constants/supportChains'
import { NewIconButton } from 'views/BuyCrypto/components/NewIcon'

export type ConfigMenuDropDownItemsType = DropdownMenuItems & { hideSubNav?: boolean }
export type ConfigMenuItemsType = Omit<MenuItemsType, 'items'> & { hideSubNav?: boolean; image?: string } & {
  items?: ConfigMenuDropDownItemsType[]
}

const addMenuItemSupported = (item, chainId) => {
  if (!chainId || !item.supportChainIds) {
    return item
  }
  if (item.supportChainIds?.includes(chainId)) {
    return item
  }
  return {
    ...item,
    disabled: true,
  }
}

const config: (
  t: ContextApi['t'],
  isDark: boolean,
  languageCode?: string,
  chainId?: number,
) => ConfigMenuItemsType[] = (t, isDark, languageCode, chainId) =>
  [
    {
      label: t('Trade'),
      icon: SwapIcon,
      fillIcon: SwapFillIcon,
      href: '/swap',
      showItemsOnMobile: false,
      items: [
        {
          label: t('Swap'),
          href: '/swap',
        },
        {
          label: t('Liquidity'),
          href: '/liquidity',
        },
      ].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: t('Earn'),
      href: '/farms',
      icon: EarnIcon,
      fillIcon: EarnFillIcon,
      image: '/images/decorations/pe2.png',
      supportChainIds: SUPPORT_FARMS,
      items: [
        {
          label: t('Farms'),
          href: '/farms',
          supportChainIds: SUPPORT_FARMS,
        },
        {
          label: t('Pools'),
          href: '/pools',
          supportChainIds: POOL_SUPPORTED_CHAINS,
        },
        {
          label: t('NFT Pools'),
          href: '/nft-pools',
          supportChainIds: NFT_POOL_SUPPORTED_CHAIN_IDS,
        },
      ].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: t('DackiePad'),
      icon: IfoIcon,
      href: '/ido',
      showItemsOnMobile: false,
      items: [].map((item) => addMenuItemSupported(item, chainId)),
      supportChainIds: DACKIE_PAD_SUPPORTED_CHAIN_IDS
    },
    {
      label: 'Bridges',
      href: '#',
      icon: BridgeIcon,
      hideSubNav: true,
      items: [
        {
          label: t('BASE Native Bridge'),
          href: 'https://bridge.base.org/',
          type: DropdownMenuItemType.EXTERNAL_LINK,
        },
        {
          label: t('SquidRouter Bridge'),
          href: 'https://app.squidrouter.com/',
          type: DropdownMenuItemType.EXTERNAL_LINK,
        },
        {
          label: t('Orbiter Bridge'),
          href: 'https://www.orbiter.finance/',
          type: DropdownMenuItemType.EXTERNAL_LINK,
        },
      ].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: '',
      href: '/info',
      icon: MoreIcon,
      hideSubNav: true,
      items: [
        {
          label: t('Analytics'),
          href: '/info',
          icon: BscScanIcon,
          showItemsOnMobile: false,
          supportChainIds: INFO_SUPPORTED_CHAIN_IDS
        },
        {
          label: t('QuackPoints'),
          href: '/points',
        },
        {
          type: DropdownMenuItemType.DIVIDER,
        },
        {
          label: t('Docs'),
          href: 'https://docs.dackieswap.xyz',
          type: DropdownMenuItemType.EXTERNAL_LINK,
        },
      ].map((item) => addMenuItemSupported(item, chainId)),
    },
  ].map((item) => addMenuItemSupported(item, chainId))

export default config
